import {useLanguage} from "../LanguageContext";
import {useEffect} from "react";

export const PageTitle = ({title}) => {
    usePageTitle(title);
    return null;
};

const usePageTitle = (titleKey) => {
    const {t} = useLanguage();

    useEffect(() => {
        document.title = t(titleKey);
    }, [t, titleKey]);
};
